import { createContext } from 'react';
var IconContext = createContext({});
export default IconContext;
